module.exports = __webpack_public_path__ + "img/microplastics-1-mobile.736efbac.png";